/* Benzene SS26 - shared behaviors ported from the prototype runtime scripts.
   Vanilla JS, no framework. Covers: VCR menu, announcement ticker dismiss,
   hide-on-scroll header (dialog-bar variant), fail-open scroll reveals,
   live cart count. */
(function () {
  'use strict';

  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- VCR full-screen menu ---- */
  var menuBtn = document.getElementById('bnz-menu-btn');
  var menuClose = document.getElementById('bnz-menu-close');
  var menu = document.getElementById('bnz-vcr-menu');

  function setMenu(open) {
    if (!menu) return;
    menu.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (menuBtn) menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var t = open ? menuClose : menuBtn;
    if (t && t.focus) t.focus();
  }
  if (menuBtn) menuBtn.addEventListener('click', function () { setMenu(menu && menu.hidden); });
  if (menuClose) menuClose.addEventListener('click', function () { setMenu(false); });
  if (menu) {
    menu.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (a) setMenu(false);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && !menu.hidden) setMenu(false);
  });

  /* ---- Announcement ticker: dismiss persists for the session ---- */
  var ticker = document.getElementById('bnz-ticker');
  if (ticker) {
    var KEY = 'bnz-ticker-dismissed';
    try { if (sessionStorage.getItem(KEY) === '1') ticker.hidden = true; } catch (err) { /* private mode */ }
    var dismiss = ticker.querySelector('[data-bnz-ticker-dismiss]');
    if (dismiss) dismiss.addEventListener('click', function () {
      ticker.hidden = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (err) { /* private mode */ }
    });
  }

  /* ---- Header hide-on-scroll (dialog-bar variant only; fascia stays pinned) ---- */
  var header = document.querySelector('[data-bnz-header="dialog"]');
  if (header) {
    var lastY = window.scrollY || 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var down = y > lastY + 4, up = y < lastY - 4;
      var menuOpen = menu && !menu.hidden;
      if (menuOpen || y < 90) header.style.transform = 'translateY(0)';
      else if (down) header.style.transform = 'translateY(-100%)';
      else if (up) header.style.transform = 'translateY(0)';
      if (down || up) lastY = y;
    }, { passive: true });
  }
  var fascia = document.querySelector('[data-bnz-header="fascia"]');
  if (fascia) {
    window.addEventListener('scroll', function () { fascia.style.transform = 'translateY(0)'; }, { passive: true });
  }

  /* ---- Fail-open scroll reveals: only below-fold elements hide; a timer
     restores everything as a last resort ---- */
  if (!rm && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = e.target.dataset.bnzRot || 'none';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    var vh = window.innerHeight;
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top > vh) {
        el.dataset.bnzRot = el.style.transform;
        el.style.transition = 'opacity .9s cubic-bezier(.22,.61,.36,1), transform .9s cubic-bezier(.22,.61,.36,1)';
        el.style.opacity = '0';
        el.style.transform = 'translateY(16px)';
        io.observe(el);
      }
    });
    setTimeout(function () {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        if (el.dataset.bnzRot !== undefined) { el.style.opacity = '1'; el.style.transform = el.dataset.bnzRot; }
      });
    }, 8000);
  }

  /* ---- Live cart count (REC dot badge) ---- */
  function renderCartCount(count) {
    document.querySelectorAll('[data-bnz-cart-count]').forEach(function (el) {
      el.textContent = count;
      var badge = el.closest('[data-bnz-cart-badge]');
      if (badge) badge.hidden = count < 1;
    });
  }
  window.bnzSetCartCount = renderCartCount;
  function syncCart() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartCount(cart.item_count); })
      .catch(function () { /* offline: keep server-rendered count */ });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncCart(); });
})();
